import { SpektrixApiStrategy } from './SpektrixApiStrategy';
import type { ApiStrategy } from '../FormHandler';

export interface StrategyFactory {
    createStrategy(formElement: HTMLFormElement): ApiStrategy;
}

class AjaxApiStrategyFactory implements StrategyFactory {
    static createStrategy(formElement: HTMLFormElement): ApiStrategy {

        const apiType = formElement.getAttribute('data-api-type');
        const apiEndpoint = formElement.getAttribute('data-api-endpoint');

        if (typeof apiEndpoint !== 'string' || apiEndpoint.trim() === '') {
            throw new Error('API endpoint is required');
        }

        switch (apiType) {
        case 'spektrix':
            return new SpektrixApiStrategy(apiEndpoint);

        default:
            throw new Error(`Unknown API type: ${apiType}`);
        }
    }
}

export { AjaxApiStrategyFactory };
